import React, { useEffect, useLayoutEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Style/typo.css'
import './assets/css/style-page-aicall.css';
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";

function AICallKO() {
    const scrollToId = (id, offset = 80) => {
        const el = document.getElementById(id);
        if (!el) return;
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
    };
    
    return (
        <div className="indexpage-AICallKO">
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <div className="container-aicall-content">
                {/* Banner section */}
                <div className="AICall-ko-banner">
                    <div className="aicall-ko-banner-gradient">
                        <FadeInSection>
                            <div className="aicall-ko-banner">
                                <div className="aicall-ko-banner-content">
                                    <h1 class="typo-32-mb aicall-title">
                                        AI 전화 란 ?
                                    </h1>
                                    <p class="typo-21-sm aicall-desc">고객과의 모든 통화 이력을 저장·관리하는 솔루션입니다. <br />
                                    AI 기술을 통하여 통화이력을 텍스트로 추출하고 <br />
                                    번역 및 요약 기능을 제공합니다.
                                    </p>
                                    <div className="aicall-banner-btn-group">
                                        <button className="typo-16 typo-medium btn--default btn--primary"><a class="ai-call-ko-btn-url" href="https://hanbiro.com/#/aicall-free-trial">데모신청</a></button>
                                        <button className="typo-16 typo-medium btn--default btn--secondary"><a class="" href="https://hanbiro.com/#/pricing">요금안내</a></button>
                                    </div>
                                    
                                </div>
                                <div className="aicall-ko-nav-cards">
                                    <div className="aicall-ko-nav-cards-inner">
                                        <div className="aicall-card-grid">
                                            <button 
                                                type="button" 
                                                className="typo-21 aicall-card btn--default btn--secondary" 
                                                onClick={() => scrollToId("advantage")} 
                                                aria-controls="advantage">AI 전화 장점</button>
                                            <button 
                                                type="button" 
                                                className="typo-21 aicall-card btn--default btn--secondary" 
                                                onClick={() => scrollToId("process")} 
                                                aria-controls="process">AI 호출 프로세스</button>
                                            <button 
                                                type="button" 
                                                className="typo-21 aicall-card btn--default btn--secondary"
                                                onClick={() => scrollToId("features")}
                                                aria-controls="features">AI 전화 기능</button>
                                            <button 
                                                type="button" 
                                                className="typo-21 aicall-card btn--default btn--secondary"
                                                onClick={() => scrollToId("install")}
                                                aria-controls="install">AI 전화 설치 가이드</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>      
                </div> {/* End banner section */}
                {/* Advantage section */}
                <div className="aicall-ko-advantage-container" id="advantage">
                    <FadeInSection>
                        <h2 className="typo-32 typo-medium text-center">AI 전화 장점</h2>

                        <div className="aicall-ko-advantage-grid">
                            {/* Card 1 */}
                            <article className="aicall-ko-advantage-card">
                                <div className="adv-card-header">
                                    <p className="typo-21 typo-medium">텍스트 변환</p>
                                    <span className="adv-icon" aria-hidden="true"><img src="https://hanbiro.com/assets/images/cloud/ai-call-highlight-text-to-speech.png" /></span>
                                </div>
                                <p className="typo-16 aicall-ko-advantage-card-text">
                                    AI가 고객과의 통화 내용을 자동으로 텍스트로  변환합니다.
                                    담당자의 수동 확인 과정 없이, 중요한 데이터를 정확하게 기록합니다.
                                    검색과 필터링을 통해 후속 업무에 필요한 정보를 손쉽게 확보합니다.
                                </p>
                                
                            </article>

                            {/* Card 2 */}
                            <article className="aicall-ko-advantage-card">
                                <div className="adv-card-header">
                                    <p className="typo-21 typo-medium">번역</p>
                                    <span className="adv-icon" aria-hidden="true"><img src="https://hanbiro.com/assets/images/cloud/ai-call-highlight-translation.png" /></span>
                                </div>
                                <p className="typo-16 aicall-ko-advantage-card-text">
                                    다국어 통화 내용을 번역을 통하여 해외 고객과의 
                                    통화 내용도 언어 장벽 없이 이해하고 대응합니다. 
                                    이로 인해, 해외 고객과의 소통 문제에 대한 시간과
                                    노력 낭비를 줄여주고, 다국적 고객을 대상으로 한
                                    글로벌비즈니스가 원활하게 이루어집니다.
                                </p>
                                
                            </article>

                            {/* Card 3 */}
                            <article className="aicall-ko-advantage-card">
                                <div className="adv-card-header">
                                    <p className="typo-21 typo-medium">요약</p>
                                    <span className="adv-icon" aria-hidden="true"><img src="https://hanbiro.com/assets/images/cloud/ai-call-highlight-summary.png" /></span>
                                </div>
                                <p className="typo-16 aicall-ko-advantage-card-text">
                                    통화 내용에서 중요한 핵심 정보를 추출·요약하여 
                                    복잡하고 긴 대화를 간단하고명확하게 제공합니다. 요약된 정보를 통해 고객의 요청에 빠르게 응답함
                                    으로써 응대 품질을 개선합니다.
                                </p>
                                
                            </article>
                        </div>
                    </FadeInSection>
                </div> {/* End Advantage section */}
                {/* Process section */}
                <div className="aicall-ko-process-section" id="process">
                    <div className="aicall-ko-process-container">
                        <FadeInSection>
                            <h2 className="typo-32 typo-medium text-center">AI 호출 프로세스</h2>
                            <div className="aicall-ko-process-layout">
                                {/* Left: audio card */}
                                <span className="aicall-ko-audio-card" aria-label="Call example card">
                                    <img src="https://hanbiro.com/assets/images/cloud/ai-call-summary-ko-1.png" />
                                </span>
                                {/* Right: 4 step cards */}
                                <div className="aicall-ko-process-right">
                                    <article className="process-card">
                                        <span className="proc-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="28" height="22">
                                        <path d="M320 368c0 59.5 29.5 112.1 74.8 144L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"/></svg></span>
                                        <div>
                                            <p className="typo-21 typo-medium">고객 정보 팝업</p>
                                            <p className="typo-16 proc-desc">과거 통화 이력 확인</p>
                                        </div>
                                    </article>

                                    <article className="process-card">
                                        <span className="proc-icon" aria-hidden="true">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="28" height="28">
                                        <path d="M505 41l-135 135 46.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 46.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"/></svg>
                                        </span>
                                        <div>
                                            <p className="typo-21 typo-medium">AI 통화</p>
                                            <p className="typo-16 proc-desc">전화 수 · 발신</p>
                                        </div>
                                    </article>

                                    <article className="process-card">
                                        <span className="proc-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="32" height="22">
                                        <path d="M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l266.5 0 6-23.9c2.8-11.3 8.6-21.5 16.8-29.7L534.6 213.1c11.6-11.6 26.3-18.5 41.4-20.5l0-64.6c0-35.3-28.7-64-64-64L64 64zm48 224l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16zm517.8 27.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"/></svg></span>
                                        <div>
                                            <p className="typo-21 typo-medium">통화 종료 후</p>
                                            <p className="typo-16 proc-desc">내용 입력, 녹취 <br />파일 자동 생성</p>
                                        </div>
                                    </article>

                                    <article className="process-card">
                                        <span className="proc-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="28" height="28">
                                        <path d="M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"/></svg></span>
                                        <div>
                                            <p className="typo-21 typo-medium">AI분석</p>
                                            <p className="typo-16 proc-desc">통화 내용 텍스트 변환</p>
                                            <p className="typo-16 proc-desc">통화 내용 요약 및 번역</p>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </div>{/* End Process section */}
                {/* Feature section */}
                <div className="aicall-ko-feature-section" id="features">
                    <FadeInSection>
                        <div className="aicall-ko-feature-container">
                            <h2 className="typo-32 typo-medium text-center">AI 전화 기능</h2>

                            <div className="aicall-ko-feature-grid">
                                {/* 1. 고객 정보 미리 확인 */}
                                <article className="feature-card">
                                    <div className="feature-card-title">
                                        <p className="typo-21 typo-medium">고객 정보 미리 확인</p>
                                        <ul className="check-list">
                                            <li className="typo-16 feature-desc">전화 수·발신 시 담당자의 PC 팝업에서 고객의 기본 정보와 과거 통화 이력을 미리 확인합니다.</li>
                                            <li className="typo-16 feature-desc">실시간으로 고객 정보에 접근하여, 불필요한 질문을 줄이고 맞춤형 서비스를 제공합니다.</li>
                                        </ul>
                                    </div>                                
                                    <div className="feature-preview preview-call-info">
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-crm-call-ko-2.png" />
                                    </div>
                                </article>

                                {/* 2. 고객 연락처 실시간 업데이트 */}
                                <article className="feature-card">
                                    <div className="feature-card-title">
                                        <p className="typo-21 typo-medium">고객 연락처 실시간 업데이트</p>
                                        <ul className="check-list">
                                            <li className="typo-16 feature-desc">신규 고객을 등록하고 기존 고객의 연락처를 최신 상태로 유지합니다.</li>
                                            <li className="typo-16 feature-desc">PC 팝업 창에서 미등록 번호를 확인하고 저장 시, 기존 고객의 연락처에 업데이트 됩니다.</li>
                                        </ul>
                                    </div>    
                                    <div className="feature-preview preview-contact">
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-info-ko-2.png" />
                                    </div>
                                </article>

                                {/* 3. 통화 녹취 및 이력 저장 · 관리 */}
                                <article className="feature-card">
                                    <div className="feature-card-title">
                                        <p className="typo-21 typo-medium">통화 녹취 및 이력 저장 · 관리</p>
                                        <ul className="check-list">
                                            <li className="typo-16 feature-desc">통화 녹취 파일은 모바일 앱과 웹에서 확인 및 다운로드 합니다.</li>
                                            <li className="typo-16 feature-desc">모든 통화 내역과 메모는 고객별로 자동 분류하여 실시간으로 저장됩니다.</li>
                                        </ul>
                                    </div>                                
                                    <div className="feature-preview preview-recorder">
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-all-calls-ko-2.png" />
                                    </div>
                                </article>

                                {/* 4. 부재중 통화 관리 */}
                                <article className="feature-card">
                                    <div className="feature-card-title">
                                        <p className="typo-21 typo-medium">부재중 통화 관리</p>
                                        <ul className="check-list">
                                            <li className="typo-16 feature-desc">담당자 부재 시 발생한 부재중 통화 이력 저장 · 관리를 통해 고객 응대 누락을 최소화합니다. </li>
                                        </ul>
                                    </div>
                                    <div className="feature-preview preview-missed">
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-missed-calls-ko-2.png" />
                                    </div>
                                </article>
                            </div>
                        </div>
                    </FadeInSection>
                </div> {/* End feature section */}
                {/* Install Guide - Install section */}
                <div className="aicall-ko-install-section" id="install">
                    <div className="aicall-ko-install-container">
                        <h2 className="typo-32 typo-medium text-center">AI 전화 설치 가이드</h2>
                        {/* Panel: 장비 목록 */}
                        <div className="install-panel">
                            <p className="typo-21 typo-medium text-center install-panel-title">필요장비</p>
                            <div className="gear-grid" role="list">
                                <div className="gear-item">
                                    <span className="gear-icon" aria-hidden="true" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        {/* switch */}
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-device-switch.png" width={30} height={21} />
                                    </span>
                                    <p className="gear-title">미러링 스위치</p>
                                    <p className="gear-sub">(8포트)</p>
                                </div>
                                <div className="gear-item">
                                    <span className="gear-icon" aria-hidden="true" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        {/* raspberry */}
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-device-raspberry.png" width={27} height={36} />
                                    </span>
                                    <p className="gear-title">라즈베리파이</p>
                                    <p className="gear-sub">(AI전화 서버)</p>
                                </div>
                                <div className="gear-item">
                                    <span className="gear-icon" aria-hidden="true" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        {/* charger */}
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-device-bolt.png" width={26} height={30} />
                                    </span>
                                    <p className="gear-title">마이크로 5핀 충전기</p>
                                    <p className="gear-sub">(라즈베리파이 전원용)</p>
                                </div>
                                <div className="gear-item">
                                    <span className="gear-icon" aria-hidden="true" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        {/* usb */}
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-device-usb.png" width={17} height={40} />
                                    </span>
                                    <p className="gear-title">USB 메모리</p>
                                </div>
                                <div className="gear-item">
                                    <span className="gear-icon" aria-hidden="true" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        {/* lan cable */}
                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-device-plug.png" width={20} height={33} />
                                    </span>
                                    <p className="gear-title">랜 케이블</p>
                                </div>
                            </div>

                            <p className="typo-16 typo-gray install-note text-center">
                                * 설치에 필요한 장비는 한비로에서 모두 제공해 드리며, 장비 비용은 200,000원(VAT 별도)입니다.
                            </p>
                        </div>

                        {/* Panel: 사전 확인사항 */}
                        <FadeInSection>
                            <div className="install-panel">
                                <p className="typo-21 typo-medium text-center install-panel-title">설치 전 고객 확인사항</p>

                                <div className="install-check-grid">
                                    <article className="check-card">
                                        <p className="typo-21 typo-medium">인터넷 전화기 사용 여부</p>
                                    <ul className="check-list">
                                        <li>AI 전화는 인터넷 전화기에서만 사용됩니다.</li>
                                        <li>설치 전, 현재 사용 중인 전화기가 인터넷 전화기인지 확인하세요.</li>
                                    </ul>
                                </article>

                                <article className="check-card">
                                    <p className="typo-21 typo-medium">전원 어댑터 및 랜케이블 준비</p>
                                    <ul className="check-list">
                                        <li>라즈베리파이와 스위칭 허브 전원용 어댑터를 준비합니다.</li>
                                        <li>랜 케이블 1개를 준비해 주세요.</li>
                                    </ul>
                                </article>

                                <article className="check-card">
                                    <p className="typo-21 typo-medium">네트워크 구조 파악</p>
                                    <ul className="check-list">
                                        <li>AI 전화 장비는 자가 설치 해 주셔야 합니다.</li>
                                        <li>원활한 설치를 위해 내부 네트워크 구성(공유기, 허브 등)을 미리 파악해 두세요.</li>
                                    </ul>
                                </article>
                            </div>
                        </div>
                        </FadeInSection>
                        {/* Panel: 설치 단계 */}
                        <FadeInSection>
                            <div className="install-panel install-steps">
                                <p className="typo-21 typo-medium text-center install-panel-title">설치 단계</p>

                                <div className="install-steps-grid">
                                    {/* Left: steps list */}
                                    <div className="steps-list">
                                        <div className="step-item">                                       
                                            <p className="typo-21 typo-black step-title1"><a className="typo-21 step-title2">1단계</a> - USB 메모리 연결</p>
                                            <ul className="typo-16 step-lines">
                                                <li>라즈베리파이 좌측 상단 첫 번째 USB 포트에 USB 메모리 꽂기.</li>
                                            </ul>
                                        </div>
                                        <div className="step-item">                                       
                                            <p className="typo-21 typo-black step-title1"><a className="typo-21 step-title2">2단계</a> - 라즈베리파이 연결</p>
                                            <ul className="typo-16 step-lines">
                                                <li>미러링 스위치 1번 포트에 라즈베리파이 연결.</li>
                                            </ul>
                                        </div>
                                        <div className="step-item">                                       
                                            <p className="typo-21 typo-black step-title1"><a className="typo-21 step-title2">3단계</a> - 네트워크 연결</p>
                                            <ul className="typo-16 step-lines">
                                                <li>미러링 스위치 2번 포트 → 공유기(업링크)</li>
                                                <li>공유기(업링크)는 메인 네트워크 장비로, 스위치와 인터넷망을 연결.</li>
                                            </ul>
                                        </div>
                                        <div className="step-item">
                                            <p className="typo-21 typo-black step-title1"><a className="typo-21 step-title2">4단계</a> - 사내 허브 연결</p>                                        
                                            <ul className="typo-16 step-lines">
                                                <li>미러링 스위치 5번 포트 → 사내 허브</li>
                                                <li>공유기(업링크)는 메인 네트워크 장비로, 스위치와 인터넷망을 연결.</li>
                                            </ul>
                                        </div>

                                        <div className="step-item">
                                            <p className="typo-21 typo-black step-title1"><a className="typo-21 step-title2">5단계</a> - 설치 위치 선정</p>
                                            <ul className="typo-16 step-lines">
                                                <li>공유기 하단 등, 음성 트래픽을 모두 잡을 수 있는 위치에 설치.</li>
                                            </ul>
                                        </div>
                                    </div>

                                    {/* Right: diagram */}
                                    <div className="steps-diagram">  
                                        <img className="aicallkocard1" src="https://hanbiro.com/assets/images/cloud/ai-call-setup-5.png" />                                  
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </div> {/* End Install Guide section */}
                <div class="aicall-ko-cta-section">
                    <FadeInSection>
                        <div class="aicall-ko-cta-container">
                            <div class="aicall-ko-suitable-for-title">
                                <p class="typo-32">AI 기반 통화의 이점은 무엇입니까?</p>
                            </div>
                            <div class="aicall-suitable-for-content">
                                <div class="aicall-suitable-for-sub-content">
                                    <div class="aicall-ko-item">
                                        <p class="typo-21-sm typo-medium item-title">기업용</p>
                                        <ul className="typo-16 step-lines">
                                            <li>음성 트래픽을 모두 수집할 수 있는 공유기 하단 등에 설치합니다.</li>
                                            <li>반복적이고 수작업인 통화 기록 요약·번역 하는등의 후처리를 자동화함으로써<br />인건비를 절감하고 통화당 처리 시간을 단축하여 더 많은 고객을 신속히 응대합니다.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="aicall-suitable-for-sub-content">
                                    <div class="aicall-ko-item">
                                        <p class="typo-21-sm typo-medium item-title">고객 서비스 담당자용</p>
                                        <ul className="typo-16 step-lines">
                                            <li>팝업 알림을 통한 실시간 고객 정보 확인으로 더 빠르게 응대합니다.</li>
                                            <li>음성 텍스트 변환으로 통화를 다시 듣고 정리하는 시간을 단축합니다.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="aicall-suitable-for-sub-content">
                                    <div class="aicall-ko-item">
                                        <p class="typo-21-sm typo-medium item-title">고객용</p>
                                        <ul className="typo-16 step-lines">
                                            <li>통화 내역을 통해 같은 내용을 반복 설명할 필요 없이 신속하고 정확한 답변을 받습니다.</li>
                                            <li>고객관리 데이터를 기반으로 고객 맞춤형 서비스를 제공합니다.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
                {/* <div class="ai-call-register-section">
                    <div class="ai-call-register-content bottom-cta">
                        <div class="register-content">
                            <p class="typo-32 typo-medium typo-white mb-2">사업을 다음 단계로 끌어올릴 준비가 되셨나요?</p>
                            <p class="typo-16 typo-white">일상적인 통화를 단순한 대화로만 끝내지 마세요.</p> 
                            <p class="typo-16 typo-white">AI 통화를 귀중한 자산으로 전환하고 생산성을 높이고 수익을 늘리세요!</p>
                        </div>
                        <div className="ai-call-cta theme-purple">
                            <button class="typo-16 typo-medium ai-call-register-trial-button btn--default btn--primary">
                                <a class="ai-call-btn-url" href="https://hanbiro.com/#/aicall-free-trial">무료 평가판</a>
                            </button>
                        </div>
                    </div>
                </div> */}
            </div>
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default AICallKO;